module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function (fox, $) {
	'use strict';

	fox.registerWidget('SitePage_Affiliates', {
		configure: function () {
			this._defPayMethods = {
				widget: 'Widget',
				group: 'payoutMethods',
				active: false,
				autoRender: true,
				'embed.container': '#aff-methods-container'
			};

			this.registerOptions('', {
				autoRender: true,
				widgets: {
					checkMethod: fox.merge({
						template: 'sitepage_affiliates_check_method'
					}, this._defPayMethods),
					paxumMethod: fox.merge({
						template: 'sitepage_affiliates_paxum_method'
					}, this._defPayMethods),
					payoneerMethod: fox.merge({
						template: 'sitepage_affiliates_payoneer_method'
					}, this._defPayMethods),
					wireMethod: fox.merge({
						template: 'sitepage_affiliates_wire_method'
					}, this._defPayMethods),
					signupApi: {
						widget: 'Api',
						method: 'affiliate.register',
						address: '/affiliates/api.php'
					},
					signUpSuccessMessage: {
						widget: 'Widget',
						template: 'sitepage_affiliates_signup_success_message',
						'embed.container': '#aff-reg-block',
						active: false,
						group: 'regForm',
						autoRender: true
					},
					regFormBlock: {
						widget: 'Widget',
						autoRender: true,
						active: true,
						group: 'regForm',
						template: 'sitepage_affiliates_reg_form_block',
						'embed.container': '#aff-reg-block',
						'widgets.mainForm': {
							widget: 'Form',
							loadValuesOnRun: false,
							autoApply: true,
							formElements: {
								screenName: {element: '[name=screenName]'},
								domain: {
									element: '[name=domain]',
									validate: [{validator: 'regexp', options: {regexp: fox.regexp.url}, message: 'Wrong domain name format'}]
								},
								company: {element: '[name=company]'},
								email: {
									element: '[name=email]',
									validate: [{validator: 'regexp', options: {type: 'emailCaseInsensitive'}, message: 'Wrong email format'}]
								},
								phone: {element: '[name=phone]'},
								socialAcount: {element: '[name=socialAcount]'},
								socialIdentity: {element: '[name=socialIdentity]'},
								firstName: {element: '[name=firstName]'},
								lastName: {element: '[name=lastName]'},
								address: {element: '[name=address]'},
								addressCont: {element: '[name=addressCont]'},
								city: {element: '[name=city]'},
								state: {element: '[name=state]'},
								zip: {element: '[name=zip]'},
								country: {element: '[name=country]'},
								'consent_tos': {element:'[name=consent_tos]'},
								'consent_marketing': {element: '[name=consent_marketing]'}
							},
							submit: {
								target: '#signup',
								event: 'click'
							},
							'hooks.onSubmit': '@parent @parent:submitSignUp',
							'widgets.validator': {
								widget: 'Easy_Form_Validator',
								hangClassLocation: 'parentNode',
								requiredFields: ['screenName', 'domain', 'phone', 'email', 'lastName', 'firstName', 'consent_tos'],
								formWidget: '@parent',
								defaultValidator: [{
									validator: 'length',
									options: {min: 1},
									message: 'This field is required'
								}]
							}
						},
						handleDom:{
							focus: {
								target: 'input[name]',
								event: 'focus',
								callback: '@parent:_handleFocus'
							}
						}
					}
				},
				handleWom: {
					formError: {
						event: 'formNotValid',
						widget: '#regFormBlock #mainForm #validator',
						callback: 'mainFormNotValid'
					},
					signupApiResponse: {
						event: ['success', 'error', 'failure'],
						widget: '#signupApi',
						callback: 'signupApiResponse'
					},
					elementsUpdated: {
						widget: '#regFormBlock #mainForm',
						event: 'elementsUpdated',
						callback: 'checkMarketingConsent'
					}
				},
				handleDom: {
					customizeSelect: {
						event: 'change',
						target: 'select',
						targetWidget: '#regFormBlock',
						callback: 'handleChange'
					},
					selectMethod: {
						event: 'change',
						target: '[name=payoutMethods]',
						targetWidget: '#regFormBlock',
						callback: 'selectMethod'
					},
					scrollTo: {
						event: 'click',
						target: ['#aff-scroll-to-register', '#aff-scroll-to-login', '#aff-scroll-to-register_join'],
						callback: 'scrollTo'
					},
					showLogin: {
						event: 'click',
						target: '#aff-fake-scroll-to-login',
						callback: '@parent:showHideLoginForm'
					}
				}
			});
		
			this.callParent('configure', arguments);
		},

		running: function () {
			if (!fox.site.getOption('hasAffiliate')) {
				fox.site._gotoPage('404');
				return;
			}
			this.mf = this.rwom1('#regFormBlock #mainForm');

			this.handleEvent('#regFormBlock', 'addedToDom', 'customizeOnAdd');	
		
			this.callParent('running', arguments);
		},

		handleChange: function (el) {
			this._customizeSelect(el);
		},

		_customizeSelect: function (el) {
			var curValue;

			if ((curValue = $(el).parent().find('.selected-text'))) {
				curValue.text($(el).find('option:selected').text());
			}
		},

		customizeOnAdd: function (o, p) {
			fox.each(p.dom('select'), this._customizeSelect);
		},

		selectMethod: function (el) {
			try {
				this.switchEmbeddedWidget(el.value);
			} catch (e) {
				
			}
		},

		scrollTo: function (el) {
			$('body, html').animate({
				scrollTop: $($(el).data('scroll-to')).offset().top
			}, 500);
		},

		submitSignUp: function () {
			var api, formData;

			api =  this.rwom1('#signupApi');
			formData = this.mf.collectData();

			api.send(formData);

		},

		_handleFocus: function (el) {
			$(el).parent().removeClass('error').find('.error-container').text('');
		},

		mainFormNotValid: function (data) {
			fox.each(data.errorStack, function (val, alias) {
				var err = val[0];

				$(this.dom1('[name="' + alias + '"]'))
					.parent()
					.find('.error-container')
					.text(err.message);
			}, this);
		},

		signupApiResponse: function (res) {
			if (res.answer.response) {
				this.switchEmbeddedWidget('signUpSuccessMessage');
			}
			// temporary
			if (!res.answer.status) {
				var field;

				field = this.rwom1('#regFormBlock').dom1('[name=email]');

				fox.dom.addClass('error', field.parentNode);

				$(field).next().find('.error-container').text(res.answer.reason);
			}
		},

		rendering: function () {
			this.setTemplateOptions(this.getParent().clientData);

			this.callParent('rendering', arguments);
		},

		checkMarketingConsent: function() {
			if (fox.getEnv('defaultMarketingConsentValue') === 'true') {
				this.wom1('#regFormBlock #mainForm #consent_marketing').setValue(true);
			}
		}

	}, 'Site_Page');

})(fox, fox.jQuery);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/affiliate/widget/sitepage/affiliates.js
// module id = 180
// module chunks = 4